import {
  BaseRequestQueryParam,
  CasinoGameResponseModel,
  DashboardResponseModel,
  GameResponseModel,
  HttpResponse,
  PlayGameResponseModel,
} from 'models';
import axiosClient, { handleRequest } from './axiosClient';
import { getLocalStorage } from 'utils/sessionStorage';

const gameApi = {
  getDashboard: (params?: BaseRequestQueryParam): Promise<HttpResponse<DashboardResponseModel>> => {
    const url = '/casino/api/games/dashboard';
    return handleRequest(axiosClient.get(url, { params }));
  },
  getGames: (params?: BaseRequestQueryParam): Promise<HttpResponse<CasinoGameResponseModel[]>> => {
    const url = '/casino/api/games';
    return handleRequest(axiosClient.get(url, { params }));
  },
  playGame: (id: string): Promise<HttpResponse<PlayGameResponseModel>> => {
    const url = `/casino/api/games/${id}/play`;
    return handleRequest(
      axiosClient.post(url, null, {
        headers: {
          Authorization: `Bearer ${getLocalStorage('access_token_terabet')}`,
        },
      }),
    );
  },
  playForFun: (id: string): Promise<HttpResponse<PlayGameResponseModel>> => {
    const url = `/casino/api/games/${id}/play-for-fun`;
    return handleRequest(axiosClient.post(url));
  },
  playPoker: (): Promise<HttpResponse<PlayGameResponseModel>> => {
    const url = '/casino/api/games/play-poker';
    return handleRequest(
      axiosClient.post(url, null, {
        headers: {
          Authorization: `Bearer ${getLocalStorage('access_token_terabet')}`,
        },
      }),
    );
  },
  likeGame: (id: string) => {
    const url = `/terabet/api/games/like/${id}`;
    return handleRequest(
      axiosClient.post(url, null, {
        headers: {
          Authorization: `Bearer ${getLocalStorage('access_token_terabet')}`,
        },
      }),
    );
  },
  dislikeGame: (id: string) => {
    const url = `/terabet/api/games/dislike/${id}`;
    return handleRequest(
      axiosClient.post(url, null, {
        headers: {
          Authorization: `Bearer ${getLocalStorage('access_token_terabet')}`,
        },
      }),
    );
  },
  getGamesScore: (params?: BaseRequestQueryParam): Promise<HttpResponse<GameResponseModel[]>> => {
    const url = '/terabet/api/games/game-score';
    return handleRequest(axiosClient.get(url, { params }));
  },
};

export default gameApi;
